import { render, staticRenderFns } from "./HorseLamp.vue?vue&type=template&id=32f4679e&scoped=true"
import script from "./HorseLamp.vue?vue&type=script&lang=js"
export * from "./HorseLamp.vue?vue&type=script&lang=js"
import style0 from "./HorseLamp.vue?vue&type=style&index=0&id=32f4679e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f4679e",
  null
  
)

export default component.exports